import axios from "axios";

const PROXY_URL = "/api/contact";

export const createOdooLead = async (payload) => {
  try {
    const response = await axios.post(PROXY_URL, payload, {
      headers: { "Content-Type": "application/json" },
      timeout: 15000,
    });

    // Return the response data
    return response.data;
  } catch (error) {
    // Normalize error message to a readable string
    const normalize = (err) => {
      try {
        if (!err) return 'Unknown error';
        // axios error with response
        if (err.response) {
          const d = err.response.data;
          if (d) {
            if (typeof d === 'string') return d;
            if (d.error) {
              if (typeof d.error === 'string') return d.error;
              if (d.error.message) return d.error.message;
              return JSON.stringify(d.error);
            }
            if (d.message) return d.message;
            return JSON.stringify(d);
          }
          return `HTTP ${err.response.status}`;
        }
        // regular Error
        if (err.message) return err.message;
        // fallback stringify
        return typeof err === 'object' ? JSON.stringify(err) : String(err);
      } catch (e) {
        return 'Unknown error';
      }
    };

    const msg = normalize(error);
    throw new Error(msg);
  }
};
